import { useMutation } from "@apollo/client";
import { RedeemPromotionCodeMutation, RedeemPromotionCodeMutationVariables } from "@ctypes";
import { PROMOTIONAL_DOLLAR_QUERY } from "@graphql";
import { REDEEM_PROMO_CODE } from "@graphql/mutations";

export const useRedeemPromoCode = () => {
  return useMutation<RedeemPromotionCodeMutation, RedeemPromotionCodeMutationVariables>(
    REDEEM_PROMO_CODE,
    {
      refetchQueries: [{ query: PROMOTIONAL_DOLLAR_QUERY }],
      awaitRefetchQueries: true,
    },
  );
};
